exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background: #f5f5f5;\n  color: #333;\n  height: 30px;\n  position: fixed;\n  left: 0px;\n  bottom: 0px;\n  width: 100%;\n  text-align: right;\n  padding-right: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/footer/footer.component.scss
// module id = ../../../../../src/app/core/footer/footer.component.scss
// module chunks = main